import { createRoutine } from "redux-saga-routines";

export const tokenRoutine = createRoutine("API_USER_TOKEN");
